import Vue from 'vue';
import "./fonts/iconfont.css"

    import { slice } from "../../../src/filters"

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
import {
  Menu,
  MenuItem,
  Carousel,
  CarouselItem,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Submenu,
  Drawer,
  MessageBox
} from "element-ui"

export default {
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [Submenu.name]: Submenu,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
    [DropdownItem.name]: DropdownItem
  },
  // ref: https://github.com/kopiro/siriwave#constructor-options
  props: {
    logo: {
      default: ""
    },
    defaultActived: {
      default: ""
    },
    menus: {
      default: []
    },
    user: {
      default: {}
    },
    IMBaseUrl: {
      default: ""
    },
    ENV: {
      default: "dev"
    },
    logoutUrl: {
      default: ""
    },
    appName: {
      default: "xreports"
    },
    badgeCount: {
      default: null
    },
    params: {
      default: () => {
        return { theme: "white" }
      }
    },
    hotelname: {
      default: ""
    },
    pcPageBlack: {
      default: () => []
    },
    modules: {
      default: () => []
    },
    guideInfo: {
      default: () => ({
        guideSteps: [],
        completeCallback: () => {}
      })
    }
  },
  filters: {
    slice
  },
  data() {
    return {
      collapse: false,
      newMenu: [],
      shortMenus: [],
      defaultActivedMenu: "/hotelcem/home",
      drawer: false,
      currentMenu: {
        parentPath: []
      },
      brandStyles: {},
      currentRoute: {},
      iconCount: 0,
      device: "pc",
      IM_BASEURL: {
        dev: "https://im-fat.vocustcloud.com?generateKey=BemQMQYlfES2auforI9qlMtVQ3RXkT/zc1J2EU6zYh/VdbKXPTQurQ==",
        fat: "https://im-fat.vocustcloud.com?generateKey=BemQMQYlfES2auforI9qlMtVQ3RXkT/zc1J2EU6zYh/VdbKXPTQurQ==",
        fort: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg==",
        prod: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg==",
        uat: "https://cdn.vocustcloud.com/im-client/index.html?generateKey=BemQMQYlfET9L+/soCEv+CE7HZcITB2ALUKR8a2v6HojJciUmLZPNg=="
      },
      REDIRECT_CASURL: {
        dev: "https://login-fat.vocust.com",
        fat: "https://login-fat.vocust.com",
        fort: "https://login.vocust.com",
        prod: "https://login.vocust.com",
        uat: "https://login-uat.vocust.com"
      },
      curSelectedParentPath: "",
      menuIntroductions: {},
      menuBanners: {},
      brandLogo: "",
      brandLogoWhite: "",
      matchedCustomerLogo: false,
      specialTenantLogo: {
        315430: ""
      },
      headerWidth: "calc(100vw - 200px)",
      columnWidth: "250px",
      oldValueSnapshot: null,
      langText: {
        en: {
          changeMode: "Revert to old nav",
          hello: "Hello,"
        },
        "zh-cn": {
          changeMode: $t("b25692821fba7ab1"),
          hello: $t("de6d10e5acd01f70")
        }
      }
    }
  },
  watch: {
    "user.tenantId": {
      handler(newVal) {
        // if (["479640"].includes(newVal)) {
        //   this.brandStyles = { height: "auto", width: "110px" }
        // }
        if (["315430", "334886"].includes(newVal)) {
          // return require("./images/brand_shangmei_logo.png")
          import("./images/brand_shangmei_logo.png").then(({ default: img }) => {
            this.brandLogo = img
            this.matchedCustomerLogo = true
          })
        } else if (["866529", "940263"].includes(newVal)) {
          // 唯品会
          // return require("./images/brand_weipinhui_logo.png")
          import("./images/brand_weipinhui_logo.png").then(({ default: img }) => {
            this.brandLogo = img
            this.matchedCustomerLogo = true
          })
        } else if (["479640"].includes(newVal)) {
          // CITC
          // return require("./images/brand_citc_logo.png")
          import("./images/brand_citc_logo.png").then(({ default: img }) => {
            this.brandLogo = img
            this.matchedCustomerLogo = true
          })
        } else {
          this.brandLogo = require("./images/voc_brand_logo.png")
          this.brandLogoWhite = require("./images/voc_brand_logo_white.png")
        }
      },
      immediate: true
    },
    $route: {
      handler() {
        console.log("this.$route", this.$route)
        this.defaultActivedMenu = this.transformPath(this.$route.path)
        this.currentMenu = {
          parentPath: []
        }
        this.findCurrentMenu(this.menus)
      },
      deep: true,
      immediate: true
    },
    menus: {
      async handler(newVal) {
        if (!this.isSame(newVal, this.oldValueSnapshot)) {
          this.initMenu(newVal)
        }
        if (newVal) {
          this.oldValueSnapshot = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    activePath() {
      const code = this.transformPath(this.$route.path)
      if (code) {
        const path = this.getOpenSubMenu(code, this.menus, [])
        return path?.map(item => item.code) || []
      }
      return []
    }
  },
  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.device = "mobile"
    }
    this.initMenu(this.menus)
  },

  mounted() {
    this.getHeaderTopWidth()
    this.resizeWindow()
    this.registerObserver()
  },
  methods: {
    transformPath(path) {
      if (path === "/") {
        return path
      }
      if (path.endsWith("/")) {
        path = path.slice(0, -1)
      }
      return path
    },
    isSame(val1, val2) {
      let flag = true
      if (val1 === null || val2 === null) {
        return val1 === val2
      }
      if (typeof val1 === "object" && typeof val2 === "object") {
        const keys1 = Object.keys(val1)
        const keys2 = Object.keys(val2)
        if (keys1.length !== keys2.length) {
          return false
        }
        for (let i = 0; i < keys1.length; i++) {
          const isequal = this.isSame(val1[keys1[i]], val2[keys1[i]])
          if (!isequal) {
            flag = false
            break
          }
        }
        return flag
      }
      return val1 === val2
    },
    getIndex(route) {
      const pathArr = route.path.split("hotelcem")
      if (pathArr.length > 1) {
        return pathArr[1]
      }
      return route.path
    },
    isLeafNode(route) {
      return !route.children?.length || route.children.every(item => item.positionName === "hide")
    },
    getOpenSubMenu(code, menus, subMenusList, deep = 1) {
      for (const menu of menus) {
        if ((menu.code === code || this.getIndex(menu) === code) && this.isLeafNode(menu)) {
          if (deep === 1) {
            subMenusList.push({ code: menu.code, index: this.getIndex(menu) })
          }
          return subMenusList
        }
        if (menu.children && menu.children.length) {
          const found = this.getOpenSubMenu(code, menu.children, subMenusList, deep + 1)
          if (found) {
            subMenusList.unshift({
              code: menu.code,
              index: this.getIndex(menu)
            })
            return subMenusList
          }
        }
      }
      return null
    },
    changeMode() {
      MessageBox.confirm($t("77c1d7b636b40db9"), $t("daaaeb1b7b22b126"), {
        confirmButtonText: $t("204ffab8a6e01870"),
        cancelButtonText: $t("4b3340f7872b411f"),
        type: "warning"
      })
        .then(() => {
          this.$emit("changeMode", 1)
        })
        .catch(() => {})
    },
    filterMenuList(routes) {
      //在这一步，要把info2内的board菜单拿出来
      const menuList = []
      if (routes?.length) {
        for (const route of routes) {
          if (route.positionName === "hide") {
            continue
          }
          menuList.push({
            ...route,
            children: this.filterMenuList(route.children)
          })
        }
      }
      return menuList
    },
    initMenu(menuData) {
      let menus = JSON.parse(JSON.stringify(menuData))
      menus = this.filterMenuList(menus)
      this.newMenu = menus.map(item => {
        item.showThisMenu = true
        if (item.children) {
          item.children.map(it => {
            it.defaultSource = it.source?.split(";")[0] || ""
            it.sourceImg = it.source?.split(";")[1] || ""
            return it
          })
        }
        item.childrenAsync = []
        item.showIcon = false
        return item
      })
      this.syntheticMenuIntroductions()
    },
    resizeWindow() {
      let that = this
      window.onresize = function () {
        that.getHeaderTopWidth()
      }
    },
    registerObserver() {
      const headerColumn = this.$refs.vocHeaderColumn
      if (headerColumn) {
        const observer = new ResizeObserver(() => {
          this.getHeaderTopWidth()
        })
        observer.observe(headerColumn)
      }
    },
    getHeaderTopWidth() {
      const headerColumn = this.$refs.vocHeaderColumn
      const container = document.querySelector("#pageContainer") || headerColumn?.parentElement
      if (headerColumn && container && headerColumn.parentElement) {
        const containerWidth = container.offsetWidth
        const headerLeftWidth = headerColumn.offsetWidth
        this.headerWidth = `${containerWidth - headerLeftWidth}px`
        this.columnWidth = `${headerLeftWidth}px`
      }
    },

    handleCollapse() {
      this.collapse = !this.collapse
    },
    syntheticMenuIntroductions() {
      for (let i = 0; i < this.newMenu.length; i++) {
        this.menuIntroductions[this.newMenu[i].code] = {
          title: this.newMenu[i].name || "", // 一级标题
          desc: this.newMenu[i].remark || "", // 一级描述
          style: { width: "399px" },
          source: this.newMenu[i].source || "",
          alias: this.newMenu[i].alias
        }
      }
    },

    onChangeLanguage(language) {
      const originalLanguage = this.$root._$lang || this.$root.$root.lang
      localStorage.setItem("VOC-LANGUAGE", language)
      if (originalLanguage !== language) location.reload()
      // location.reload()
    },
    getRouteName(route) {
      const lang = this.$lang
      if (lang === "en" && route.alias) return route.alias
      else return route.name
    },

    drawerOpen() {
      if (this.$refs.carousel) this.$refs.carousel.setActiveItem(0)
      if (this.currentRoute.path) this.$refs.carouselMenu.close(this.currentRoute.path)
    },
    carouselBack() {
      this.$refs.carouselMenu.close(this.currentRoute.path)
      this.$refs.carousel.prev()
    },
    findCurrentMenu(menus = [], parentMenu = {}) {
      const that = this
      const { $route } = this
      menus.forEach(item => {
        if (
          item.code === $route.name ||
          item.path === $route.path
          // ($route.name && $route.name.indexOf(item.code) !== -1)
        ) {
          that.currentMenu = Object.assign({}, item)
          that.currentMenu.parentMenu = parentMenu
          that.currentMenu.parentName = parentMenu.code
          that.currentMenu.parentPath = []
          while (parentMenu && parentMenu.code) {
            that.currentMenu.parentPath.push(parentMenu.code)
            parentMenu = parentMenu.parentMenu
          }
        }
        if (item.children && item.children.length > 0)
          this.findCurrentMenu(item.children, { parentMenu: parentMenu, ...item })
      })
    },

    onDrawerMenuSelect(path) {
      let route = null
      this.newMenu.some(item => {
        if (item.path === path) {
          route = item
          return true
        }
      })
      this.currentRoute = route
      this.$refs.carousel.next()
    },
    onMenuSelect(item) {
      const { path } = item
      this.curSelectedParentPath = path
      this.drawer = false
      this.$emit("menuClick", item)
      this.$forceUpdate()
    },

    onSelectApplication() {
      this.$emit("onSelectApplicationClick")
      const language = localStorage.getItem("VOC-LANGUAGE")
      window.open(`${this.REDIRECT_CASURL[this.ENV]}${language === "en" ? "/en-US" : ""}/#/system-select`, "_self")
    },
    onCallIM() {
      const { user, hotelname } = this
      let nickname = hotelname ? `${hotelname}+${user.userName}` : user.userName
      window.open(`${this.IM_BASEURL[this.ENV]}&agentUid=${user.userId}&nickname=${nickname}`)
    },
    onClickCallOut() {
      if (this.ENV !== "prod") {
        window.open(`https://oc-fat.vocust.com/`)
      } else {
        window.open(`https://oc.vocust.com`)
      }
    },
    onLogout() {
      MessageBox.confirm($t("aa7e6c204c751cfa"), $t("daaaeb1b7b22b126"), {
        confirmButtonText: $t("204ffab8a6e01870"),
        cancelButtonText: $t("4b3340f7872b411f"),
        type: "warning"
      })
        .then(() => {
          if (this.logoutUrl) {
            window.location.href = `${this.logoutUrl}${
              this.logoutUrl.indexOf("?") !== -1 ? "&" : "?"
            }back=${encodeURIComponent(location.href)}`
          } else {
            this.$router.push({
              path: "/system/logout",
              query: {
                back: encodeURIComponent(location.href)
              }
            })
          }
        })
        .catch(() => {})
    },
    goPage(path) {
      window.location.href = `${window.location.origin}/${this.appName}${path}`
    },
    goSystem(path) {
      window.open(path, "_blank")
    }
  }
}
